<div class="edit-panel-header-wrapper">
    <div class="job-name-group">
        <h4 class="job-name-label job-detail-title">{{ 'TC.Common.Name' | translate }}</h4>
        <div class="job-name">{{ job?.name }}</div>
    </div>
    <div class="job-description-group">
        <h4 class="job-description-label job-detail-title">{{ 'TC.Common.Description' | translate }}</h4>
        <div class="job-description" *ngIf="job.description; else noDescription">{{ job.description }}</div>
        <ng-template #noDescription>
            <div class="job-description no-data-label no-description">
                {{ 'Survey.SurveyEditPanel.NoDescription' | translate }}
            </div>
        </ng-template>
    </div>
</div>
